import React from 'react';

import { GoogleLogin } from 'react-google-login';
import { googleLogin } from '../services/ApiService';
import { createUseStyles } from 'react-jss';

export interface LoginGoogleProps {
    success: Function;
}

const LoginGoogle: React.FC<LoginGoogleProps> = ({ success }) => {
    const classes = useStyles();


    const onSuccess = (res: any) => {
        return (async () => {
            let body = {
                "provider_id": res.googleId,
                "name": res.profileObj.name,
                "email": res.profileObj.email,
                "social_photo": res.profileObj.imageUrl
            };
            let data = await googleLogin(body);
            console.log("res");
            console.log(res);
            console.log("data");
            console.log(data);
            data['socialPhoto'] = res.profileObj.imageUrl
            success(data)
        })()
    }
    const onFailure = (res: any) => {
        console.log("res")
        console.log(res)
    }

    return (
        <div className={classes.btnGoogleContainer}>
            <GoogleLogin
                clientId="631354353247-dot6alsjb97u60paftvabc9d00b8pkvi.apps.googleusercontent.com"
                render={renderProps => (
                    // <button onClick={renderProps.onClick} disabled={renderProps.disabled}>

                    <div onClick={renderProps.onClick} className={classes.googleBtn}>
                        <div className={classes.googleIconWrapper}>
                            <img alt="login google" className={classes.googleIcon} src="https://upload.wikimedia.org/wikipedia/commons/5/53/Google_%22G%22_Logo.svg" />
                        </div>
                        <p className={classes.btnText}><b>Login with google</b></p>
                    </div>
                    // </button>
                )}
                onSuccess={onSuccess}
                onFailure={onFailure}
                cookiePolicy={'single_host_origin'}
            />
        </div>
    )
}

const useStyles = createUseStyles({

    "googleBtn": {
        width: "184px",
        height: "42px",
        backgroundColor: "#ffffff",
        paddingLeft: "42px",
        position: "relative",
        borderRadius: "2px",
        boxShadow: "0 3px 4px 0 rgba(0, 0, 0, 0.25)",
        "&:hover": {
            boxShadow: "0 0 6px #4285f4",
            cursor: "pointer"
        },
        "&:active": {
            // background: "#1669f2"
        }
    },
    "btnGoogleContainer": {

    },
    '@media(max-width:580px)': {
        "btnGoogleContainer": {
            marginBottom: '10px',
        },
        "googleBtn": {
            width: '200px',
        },
    },
    "googleIconWrapper": {
        position: "absolute",
        marginTop: "1px",
        marginTeft: "1px",
        width: "40px",
        left: "0px",
        height: "40px",
        borderRadius: "2px",
        backgroundColor: "#fff"
    },
    "googleIcon": {
        position: "absolute",
        marginTop: "11px",
        marginLeft: "11px",
        width: "18px",
        height: "18px"
    },
    "btnText": {
        color: "#4285f4",

        paddingTop: "11px",
        textAlign: "center",
        fontSize: "14px",
        letterSpacing: "0.2px",
        fontFamily: "Roboto"
    }
})

export default LoginGoogle
